<template>
  <div v-if="opqIf">
    <infobulle :descriptionPopup="descriptionPopup">
      <label v-if="libelleLong"><div v-html="libelleLong" class="mb-1"></div></label>
      <div v-for="(file, index) in files" :key="file.name" class="d-flex">
        <file-input-base
          :width="width"
          :code="code"
          :file="file"
          :live="live"
          @file-deleted="fileDeleted"
          @file-uploaded="fileUploaded($event, index)"
          :ref="'fileInput-' + index"
          class="mb-n2"
        ></file-input-base>
        <v-btn v-if="!file.name && !file.lien" icon @click="removeEmptyFile(index)"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-btn text color="primary" @click="addFile" class="mb-6"><v-icon>mdi-plus</v-icon> Ajouter un fichier</v-btn>
      <v-checkbox
        class="list_counter_validator my-2 ml-6 p-0"
        :input-value="files && files.length > 0"
        :rules="[(v) => optional || !!v || noElementMessage]"
      ></v-checkbox>
    </infobulle>
  </div>
</template>

<script>
import FileInputBase from "@/components/Form/FileInputBase.vue"
import ChampBase from "@/mixins/ChampBase"

// @group Champs
export default {
  mixins: [ChampBase],
  props: {
    width: { type: String, default: "350" },
    code: { type: String, required: true },
    files: { type: Array, default: undefined },
    live: { type: Object },
    optional: { type: Boolean, default: false },
    opqIf: { type: Boolean, default: true },

    noElementMessage: {
      type: String,
      default: "Veuillez ajouter un fichier"
    }
  },
  data() {
    return {
      newFile: undefined
    }
  },
  components: {
    FileInputBase
  },
  methods: {
    addFile() {
      this.files.push({})
    },
    fileDeleted(id) {
      let index = this.files.findIndex((f) => f.id == id)
      this.files.splice(index, 1)
    },
    fileUploaded(fileDto, index) {
      this.$set(this.files, index, fileDto)
    },
    removeEmptyFile(index) {
      this.files.splice(index, 1)
    }
  },
  created() {
    if (this.files && this.files.length == 0 && !this.optional) {
      this.addFile()
    }
  },
  watch: {
    opqIf(newValue) {
      if (!newValue) {
        for (let i = 0; i < this.files.length; i++) {
          this.$refs["fileInput-" + i][0].deleteFile()
        }
        this.files.splice(0, this.files.length)
        this.addFile()
      }
    }
  }
}
</script>

<style>
</style>